import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";

import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {OutlineButtonComponent} from "../../outline-button/outline-button.component";
import {FroalaEditorModule} from "angular-froala-wysiwyg";
const jsDemoImagesTransform = document.createElement("script");
jsDemoImagesTransform.type = "text/javascript";
jsDemoImagesTransform.src =
  "https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image";
// Load generated scripts.
document.head.appendChild(jsDemoImagesTransform);

@Component({
    selector: 'formula',
    imports: [FontAwesomeModule, FormsModule, MatCheckboxModule, OutlineButtonComponent, FroalaEditorModule],
    templateUrl: './formula.component.html'
})
export class FormulaComponent {
  frolaFormula: string = ""

  public options: Object = {
    // Define the toolbar options for the froala editor.
    toolbarButtons: [
      'undo',
      'redo',
      'bold',
      'italic',
      '|',
      'wirisEditor',
      'wirisChemistry',
      'insertImage'
    ],
    // Add [MW] uttons to the image editing popup Toolbar.
    imageEditButtons: [
      'wirisEditor',
      'wirisChemistry',
      'imageDisplay',
      'imageAlign',
      'imageInfo',
      'imageRemove'
    ],
    // Allow all the tags to understand the mathml
    htmlAllowedTags:  ['.*'],
    htmlAllowedAttrs: ['.*'],
    // List of tags that are not removed when they have no content inside
    // so that formulas renderize propertly
    htmlAllowedEmptyTags: ['mprescripts', 'none'],
    // In case you are using a different Froala editor language than default,
    // language: 'es',
    // You can choose the language for the MathType editor, too:
    // @see: https://docs.wiris.com/en/mathtype/mathtype_web/sdk-api/parameters#regional_properties
    // mathTypeParameters: {
    //   editorParameters: { language: 'es' },
    // },
  };
}
